
/*
    A mixin providing efficient access to participant data for the current user,
    who is a participant/patient. It is similar to PractitionerPatientMixin, but it
    does not require a participantId prop to identify the patient, since that is
    the current user.

    This should only be used for patient-facing pages.
    Components within these pages that need access to the participant data should
    typically declare a participant computed variable rather than using this mixin -
    unless they contain special logic for loading or saving the participant.
    In most cases the top-level page will handle loading and saving, and embedded
    components will simply reflect the participant data.
 */

export default {
    computed: {
        participant() {
            return this.$store.state.patientParticipant
        },
        showParticipantMenuAsAccordion () {
            return this.$mq == 'sm' || this.$mq == 'md' || this.$mq == 'lg'
        },
        participantLoaded() {
            return !!this.participant && !!this.participant.id
        }
    },
    methods: {
        loadParticipant(force = false) {
            // NB: this store action will determine whether the participant
            // data has already been loaded, and will debounce multiple requests
            return this.$store.dispatch(
                'getPatientParticipant',
                {participantId: this.$user.participantId(), force: force}
            )
        },
        saveParticipant() {
            // NB: this action reloads the participant after saving
            return this.$store.dispatch('savePatientParticipant')
        },
    },
    mounted() {
        this.loadParticipant()
    }
}
